import * as React from "react";
import { Provider } from "@fluentui/react-northstar/dist/es/components/Provider/Provider";
import { useState, useEffect } from "react";
import { useTeams } from "msteams-react-base-component";
import * as microsoftTeams from "@microsoft/teams-js";
import AppInfo from "../../components/AppInfo/AppInfo";
import { CpbxThemeSelector } from "../../components/CpbxThemeSelector/CpbxThemeSelector";

/**
 * Implementation of the TabCpbxDirectory content page
 */
export const TabAppInfo = () => {

    const [{ inTeams, theme, context }] = useTeams();
    const [msTeamsUpn, setEntityId] = useState<string>();
    // check if login has been done already
    useEffect(() => {
        if (inTeams === true) {
            microsoftTeams.appInitialization.notifySuccess();
        }
        if (inTeams === false) {
            const outContext = { theme: "default" };
            CpbxThemeSelector(outContext);
        }
    }, [inTeams]);

    useEffect(() => {
        microsoftTeams.registerOnThemeChangeHandler(function(theme) {
            CpbxThemeSelector(theme);
            console.log(theme);
        });
        if (context) {
            setEntityId(context.entityId);
            CpbxThemeSelector(context);
        }
    }, [context]);

    // Theme Switcher

    return (
        <Provider className="cpbxProviderContainer">
            <AppInfo />
        </Provider>
    );
};
